<template>
    <div v-if="smoothie" class="edit-smoothie container">
        <h2 class="indigo-text center-align">Edit Smoothie {{ smoothie.title }}</h2>
        <form @submit.prevent = "editSmoothie">
            <div class="field title">
                <label for="title">Smoothie title</label>
                <input type="text" name="title" v-model="smoothie.title">
            </div>
            <div class="field" v-for="(ing, index) in smoothie.ingredients" :key="index">
                <label for="ingredient">Ingredient:</label>
                <input type="text" name="ingredient" v-model="smoothie.ingredients[index]">
                <i class="material-icons delete" @click="deleteIng(ing)">delete</i>
            </div>
            <div class="field ingredients">
                <label for="add-ingredient">Add an ingredient</label>
                <input type="text" name="add-ingredient" @keydown.enter.prevent="addIng" v-model="another">
            </div>
            <div class="field center-align">
                <p class="red-text" v-if="feedback">{{ feedback }}</p>
                <button class="waves-effect pink waves-light btn">Update Smoothie</button>
            </div>
        </form>
    </div>
</template>

<script>
import db from '@/firebase/init'
import slugify from 'slugify'
export default {
    name: 'EditSmoothie',
    data() {
        return {
            smoothie: null,
            feedback: null,
            another: null
        }
    },
    methods: {
        editSmoothie() {

            if(this.smoothie.title) {

                    this.feedback = null

                    this.slug = slugify(this.smoothie.title, {
                        replacement: '-',
                        remove: /[@()#$%^&*-+~]/g,
                        lower: true

                    })

                    db.collection('smoothies').doc(this.smoothie.id).update({

                        title: this.smoothie.title,
                        ingredients: this.smoothie.ingredients,
                        slug: this.smoothie.slug

                    }).then(() => {
                        this.$router.push({ name: 'Index' })
                    }).catch(error => {
                        console.log(error)
                    })

                } else {

                    this.feedback = "You must enter a smoothie title"

                }

        },

        addIng() {

                if(this.another) {
                    this.smoothie.ingredients.push(this.another)
                    this.another = null
                    this.feedback = null
                } else {
                    this.feedback= "You must enter a value to add an ingredient"
                }

            },

            deleteIng(ing) {

                this.smoothie.ingredients = this.smoothie.ingredients.filter(ingredient => {
                    return ingredient != ing
                })

            }
    },
    created() {
        let ref = db.collection('smoothies').where('slug', '==', this.$route.params.smoothie_slug)
        ref.get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                this.smoothie = doc.data()
                this.smoothie.id = doc.id
            });
        })
    }
}
</script>

<style>

    .edit-smoothie {

        margin-top: 1%;
        padding: 2%;
        max-width: 50vw;

    }

    .edit-smoothie input:focus-within {

        border-color: indigo !important;

    }

    .edit-smoothie h2 {

        font-size: 2em;
        margin: 5% auto;

    }

    .edit-smoothie .field {

        margin: 5% auto;
        position: relative;

    }
    
    .edit-smoothie .delete {

        cursor: pointer;
        position: absolute;
        right: 0;
        bottom: 20%;
        color: #aaa;
        font-size: 1.4em;


    }

    @media screen and (max-width: 768px) {

      .edit-smoothie {

            margin-top: 3%;
            padding: 2%;
            max-width: 100vw;

        }

    }

</style>



// WEBPACK FOOTER //
// src/components/EditSmoothie.vue